import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=b6c32e84&"
import script from "./FormLayout.vue?vue&type=script&lang=ts&"
export * from "./FormLayout.vue?vue&type=script&lang=ts&"
import style0 from "./FormLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports